<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :bizDepart="true" :showIncludeSubComs="false" :initIncludeSubComs="false" @notity-change="notityChange($event)"></swb-popover-org-tree>
        </div>
        <div name="btn-toolbar" class="simple-row">
            <div class="left">
                <button @click="saveComRoleDlg();" class='swb-btn swb-btn-small'>
                    <span>添加岗位</span>
                </button>
            </div>
        </div>
        <div name="result_table" class="table-layout">
            <el-table :data="comRoleList" border style="width: 100%">
                <el-table-column width="150" prop="name" label="岗位名称">
                    <template slot-scope="rows">
                        <i v-if="userContext.scopeEntity.bizUnitId == comInfo.bizUnitId" @click="saveComRoleDlg(false, rows.row);" class="swb-btn swb-btn-mini swb-btn-link el-icon-edit"></i>
                        <span>{{ rows.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="srcTplName" label="关联职责权限名称" width="150"></el-table-column>
                <el-table-column label="排序" width="70">
                    <template slot-scope="rows">
                        <i v-if="userContext.scopeEntity.bizUnitId == comInfo.bizUnitId" @click="moveUpComRole(rows.row.id, true)" class="icon iconfont icon-arrow-top swb-btn-link">
                        </i>
                        <i v-if="userContext.scopeEntity.bizUnitId == comInfo.bizUnitId" @click="moveUpComRole(rows.row.id, false)" class="icon iconfont icon-arrow-bottom swb-btn-link">
                        </i>
                    </template>
                </el-table-column>
                <el-table-column prop="code" width="110" label="岗位编码"></el-table-column>
                <el-table-column label="是否禁用" align="center" width="70">
                    <template slot-scope="rows">
                        <span v-if="rows.row.disabled" class="font-red">是</span>
                    </template>
                </el-table-column>
                <!--<el-table-column prop="desc" label="描述" show-overflow-tooltip></el-table-column>-->

                <el-table-column prop="mobAppRoleName" label="移动端功能" width="120">
                    <template slot-scope="rows">
                        <span v-if="rows.row.mobAppRoleName != null">可用</span>
                        <span class="font-red" v-else>不可用</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="150" prop="createTime" label="创建时间"></el-table-column>
                <el-table-column align="center" width="150" prop="rescChangeTime" label="变更时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="rows">
                        <template v-if="rows.row.srcTplId == -1">
                            <!-- 未关联职责权限：以下操作查看岗位本身的数据 -->
                            <div v-if="!rows.row.disabled" @click="showRoleRescDlg(rows.row.id, rows.row.name, rows.row.srcTplId);" class="swb-btn swb-btn-link">
                                <span>PC功能</span>
                            </div>
                            <div v-if="!rows.row.disabled" @click="showBusinessSetDlg(comInfo.id, rows.row.id, rows.row.name, rows.row.srcTplId);" class="swb-btn swb-btn-link">
                                <span>PC操作权限</span>
                            </div>
                            <div v-if="!rows.row.disabled" @click="appResc(rows.row);" class="swb-btn swb-btn-link">
                                <span>移动功能</span>
                            </div>
                        </template>
                        <template v-else>
                            <!-- 已关联职责权限：以下操作查看职责权限的信息，数据范围查看业务范围的数据 -->
                            <div v-if="!rows.row.disabled" @click="showRoleRescDlgForTpl(rows.row.srcTplId);" class="swb-btn swb-btn-link">
                                <span>PC功能</span>
                            </div>
                            <div v-if="!rows.row.disabled" @click="showBusinessSetDlgForTpl(rows.row.srcTplId);" class="swb-btn swb-btn-link">
                                <span>PC操作权限</span>
                            </div>
                            <div v-if="!rows.row.disabled" @click="appRescForTpl(rows.row.srcTplId);" class="swb-btn swb-btn-link">
                                <span>移动功能</span>
                            </div>
                            <div v-if="!rows.row.disabled" @click="bizPermScopeBusinessSetDlg(rows.row.srcTplId);" class="swb-btn swb-btn-link">
                                <span>数据范围</span>
                            </div>
                        </template>
                        <div v-if="userContext.scopeEntity.bizUnitId == comInfo.bizUnitId && !rows.row.disabled && rows.row.srcTplId == -1" @click="contactTpl(rows.row.id, rows.row.srcTplId)" class="swb-btn swb-btn-link">
                            <span>关联职责权限</span>
                        </div>
                        <div v-if="userContext.scopeEntity.bizUnitId == comInfo.bizUnitId && !rows.row.disabled && rows.row.srcTplId != -1" @click="contactTpl(rows.row.id, rows.row.srcTplId)" class="swb-btn swb-btn-link">
                            <span>更换关联职责权限</span>
                        </div>
                        <div v-if="userContext.scopeEntity.bizUnitId == comInfo.bizUnitId && !rows.row.disabled" @click="srelevPersons(rows.row);" class="swb-btn swb-btn-link">
                            <span>批量分配岗位</span>
                        </div>
                        <div v-if="userContext.scopeEntity.bizUnitId == comInfo.bizUnitId" @click="updateDisable(rows.row.id, rows.row.disabled);" class="swb-btn swb-btn-link">
                            <span v-if="rows.row.disabled">启用</span>
                            <span v-else>禁用</span>
                        </div>
                        <div v-if="userContext.scopeEntity.bizUnitId == comInfo.bizUnitId && rows.row.disabled" @click="doDelete(rows.row.id)" class="swb-btn swb-btn-link">
                            <span>删除</span>
                        </div>
                        <div @click="toQrCode(rows.row)" class="swb-btn swb-btn-link">
                            <span>岗位二维码</span>
                        </div>
                        <div @click="showRefStaffList(rows.row.id)" class="swb-btn swb-btn-link">
                            <span>查询岗位人员</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, showQrCodeImageDlg, Routes} from '../../app.vues'
    //
    import {openComRoleBusinessSetDlg, openMobAppRoleRescDlg, openMobAppRoleDlg, showComRoleStaffList, openBizPermScopeDlg} from './selectDlg';
    import {openRealStaffListForSelectDlg} from '../realStaff/selectDlg';
    //
    import servicerApi from '../../api/servicer'
    import servicerAuthxApi from '../../api/servicerAuthx'
    import realAuthxApi from '../../api/realAuthx'
    import merchtAllApi from '../../api/merchtAll'
    import userApi from '../../api/user'
    //
    import SwbSaveComRole from './SaveComRole';

    Vue.regist(SwbSaveComRole);
    import SwbComRoleRescList from './ComRoleRescList';

    Vue.regist(SwbComRoleRescList);
    import SwbMerchtTplRoleListSelect from './MerchtTplRoleListSelect';

    Vue.regist(SwbMerchtTplRoleListSelect);
    //
    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';

    Vue.regist(SwbPopoverOrgTree);

    import SwbMerchtTplRoleRescList from './MerchtTplRoleRescList';

    Vue.regist(SwbMerchtTplRoleRescList);

    import SwbMerchtTplRoleBusinessSet from './MerchtTplRoleBusinessSet';

    Vue.regist(SwbMerchtTplRoleBusinessSet);

    export default {
        name: 'swb-com-role-list',
        path: '/com/role/list',
        pathOld: '/com/role',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '公司角色列表',
        helpArticleCode: 'servicer-com-role-list',
        data: function () {
            return {
                thisComId: null,
                comInfo: {},
                comRoleList: [],
                userContext: {
                    scopeEntity: {}
                },
                bizUnitInfo: {}
            }
        },
        created: function () {
            //
            this.getUserInfoByContext();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            console.log('domHeight： ' + self.domHeight);
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout, [name="btn-toolbar"]'));
            domSizeWatcher.start(500);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            notityChange: function (eventData) {
                this.thisComId = eventData.id;
                this.getComDetail();
                this.getComRoleList();
                this.comRoleList = [];
            },
            getUserInfoByContext: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type == 'info') {
                        self.userContext = result.data;
                        self.thisComId = result.data.scopeEntity.comId;
                        self.getComRoleList();
                        self.getComDetail();
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getComDetail: function () {
                let self = this;
                let postData = {
                    comId: this.thisComId
                };
                servicerApi.getServicerCom(postData, function (result, jqXhr) {
                    if (result.type == 'info') {
                        self.comInfo = result.data;
                        self.getComDetail2(self.comInfo.bizUnitId);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getComDetail2: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                servicerApi.getServicerCom(postData, function (result, jqXhr) {
                    if (result.type == 'info') {
                        self.bizUnitInfo = result.data;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getComRoleList: function () {
                let self = this;
                let postData = {
                    comId: this.thisComId,
                };
                servicerAuthxApi.getServicerComRoleList(postData, function (result, jqXhr) {
                    if (result.type == 'info') {
                        self.comRoleList = result.data;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            saveComRoleDlg: function (isAdd, item) {
                let self = this;
                let bizUnitInfo = self.bizUnitInfo || {};
                if (Utils.isNoB(bizUnitInfo.id)) {
                    return;
                }
                isAdd = Utils.isNoB(isAdd) ? true : isAdd;
                let title = isAdd == true ? '添加岗位' : '更新岗位';
                //
                let bizUnitType = bizUnitInfo.bizUnitType;
                let theDlg = Vue.$showDialog({
                    title: title,
                    showCloseBtn: true,
                    width: 700,
                    height: 600,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                        '<swb-save-com-role :item="roleInfo" :isAdd="isAdd" :bizUnitType="bizUnitType" ref="swb_com_role"></swb-save-com-role>' +
                        '</div>',
                    data: {
                        loading: false,
                        roleInfo: null,
                        isAdd: isAdd,
                        bizUnitType: bizUnitType
                    },
                    methods: {
                        saveComRole: function () {
                            let selfDlg = this;
                            //
                            let postData = selfDlg.roleInfo;
                            postData.comLevel = self.comInfo.level;
                            postData.comId = self.comInfo.id;
                            servicerAuthxApi.saveServicerComRole(postData, function (result, jqXhr) {
                                selfDlg.loading = false;
                                if (result.type == 'info') {
                                    theDlg.close();
                                    selfDlg.$message.success('添加成功');
                                    // 重新渲染列表
                                    self.getComRoleList();
                                } else {
                                    selfDlg.$message.error(result.message);
                                }
                            });
                        },
                        updateComRole: function () {
                            let selfDlg = this;
                            //
                            let postData = selfDlg.roleInfo;
                            servicerAuthxApi.updateServicerComRole(postData, function (result, jqXhr) {
                                selfDlg.loading = false;
                                if (result.type == 'info') {
                                    theDlg.close();
                                    selfDlg.$message.success('更新成功');
                                    // 重新渲染列表
                                    self.getComRoleList();
                                } else {
                                    selfDlg.$message.error(result.message);
                                }
                            });
                        }
                    },
                    okClicked: function () {
                        // 获取弹出框中组件内容
                        let result = this.$refs.swb_com_role.getDlgResult() || {};
                        // 成功执行
                        if (result != null) {
                            if (result.type === 'info') {
                                // 处理你的信息添加赋值
                                let data = result.data;
                                if (data != null) {
                                    //
                                    data.comId = self.comInfo.id;
                                    this.roleInfo = data;
                                    this.loading = true;
                                    if (this.isAdd) {
                                        this.saveComRole();
                                    } else {
                                        this.updateComRole();
                                    }

                                }
                            }
                        } else {
                            this.$message.error('返回出错');
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                            if (!isAdd) {
                                this.roleInfo = Utils.merge({}, item);
                            }
                        }
                    }
                });
            },
            // 关联人员操作
            srelevPersons: function (row) {
                let self = this;
                let postData = {
                    roleId: row.id
                };
                realAuthxApi.getStaffIds(postData, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let realStaffIdsRo = result.data || {};
                        let realStaffIdList = realStaffIdsRo.realStaffIds || [];
                        let disabledRealStaffIds = realStaffIdsRo.disabledRealStaffIds || [];
                        let params = {
                            title: '岗位关联人员',
                            checkBox: true,
                            staffIds: realStaffIdList,
                            disabledRealStaffIds: disabledRealStaffIds,
                            filter: {}
                        };
                        //
                        openRealStaffListForSelectDlg(params, function (staffList, theDlg) {
                            staffList = staffList || [];
                            let realStaffIds = staffList.pluck('id') || [];
                            if (realStaffIdList.length > 0 && disabledRealStaffIds.length > 0) {
                                for (let i = 0; i < disabledRealStaffIds.length; i++) {
                                    let disabledRealStaffId = disabledRealStaffIds[i];
                                    if (realStaffIdList.contains(disabledRealStaffId)) {
                                        realStaffIds.add(disabledRealStaffId);
                                    }
                                }
                            }
                            let paramsX = {
                                comId: row.comId,
                                realStaffFlag: true,
                                realStaffIds: realStaffIds,
                                roleId: row.id,
                                type: 1
                            };
                            // 关联校验
                            servicerAuthxApi.examineStaffRoleChangeCondition(paramsX, function (resultX, jqXhr) {
                                let success = result.data;
                                if (resultX.type === 'info' && success) {
                                    theDlg.close();
                                    //
                                    self.doSrelevStaffsBatch(row, realStaffIds);
                                } else {
                                    MsgBox.warning(resultX.message);
                                }
                            });
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 批量关联人员
            doSrelevStaffsBatch: function (row, realStaffIds) {
                let self = this;
                let filter = {
                    roleId: row.id,
                    realStaffIds: realStaffIds
                };
                let theLoad = MsgBox.loading();
                servicerAuthxApi.doSrelevStaffsForComRole(filter, function (result, jqXhr) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        MsgBox.success('操作成功');
                        // 重新渲染列表
                        self.getComRoleList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            moveUpComRole: function (id, toUp) {
                var self = this;
                let data = {};
                data.id = id;
                data.toUp = toUp;
                servicerAuthxApi.moveServicerComRoleSeq(data, function (result, jqXhr) {
                    if (result.type == 'info') {
                        self.$message.success('操作成功');
                        // 重新渲染树列表
                        self.getComRoleList();
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // PC功能: 自建岗位
            showRoleRescDlg: function (roleId, name, srcTplId) {
                let self = this;
                let bizUnitType = self.bizUnitInfo.bizUnitType;
                //
                let ctxVipLevel = this.userContext.scopeEntity.vipLevel;
                let vipLevel = getEnumMap('vipLevel', 'value2text');
                let vipLevelName = vipLevel[ctxVipLevel] || vipLevel[0];
                Vue.$showDialog({
                    title: '岗位资源（备注：斜体、字体颜色浅的为功能资源，不是菜单！！！）vip级别【' + vipLevelName + '】',
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    okVisible: srcTplId == -1,
                    cancelText: srcTplId == -1 ? '取消' : '关闭',
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                        '   <swb-com-role-resc-list :roleId="roleId" :readOnly="readOnly" :bizUnitType="bizUnitType" ref="swb_com_role_resc" @notity-change="notityChange($event)"></swb-com-role-resc-list>' +
                        '</div>',
                    data: {
                        loading: false,
                        roleId: null,
                        readOnly: false,
                        bizUnitType: bizUnitType,
                        itemIds: []
                    },
                    methods: {
                        notityChange: function (eventData) {
                            // console.log("名称变更：" + eventData);
                        },
                        saveComRoleResc: function (data) {
                            let selfDlg = this;
                            //
                            let postData = {};
                            postData.roleId = selfDlg.roleId;
                            postData.rescIds = data;
                            servicerAuthxApi.saveServicerComRoleRescs(postData, function (result, jqXhr) {
                                selfDlg.loading = false;
                                if (result.type == 'info') {
                                    selfDlg.$message.success('添加成功');
                                    // 重新渲染列表
                                    self.getComRoleList();
                                } else {
                                    selfDlg.$message.error(result.message);
                                }
                            });
                        }
                    },
                    okClicked: function () {
                        // 获取弹出框中组件内容
                        let result = this.$refs.swb_com_role_resc.getDlgResult() || {};
                        // 成功执行
                        if (result != null) {
                            if (result.type === 'info') {
                                // 处理你的信息添加赋值
                                let data = result.data;
                                if (data != null && data.length > 0) {
                                    //
                                    this.loading = true;
                                    this.saveComRoleResc(data);
                                }
                            } else {
                                this.$message.error(result.message);
                            }
                        } else {
                            this.$message.error('返回出错');
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                            this.roleId = roleId;
                            //
                            if (srcTplId != -1) {
                                this.readOnly = true;
                            }
                        }
                    }
                });
            },
            // Pc功能 - 职责权限
            showRoleRescDlgForTpl(srcTplId) {
                Vue.$showDialog({
                    title: '岗位资源（备注：斜体、字体颜色浅的为功能资源，不是菜单！！！）',
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: '关闭',
                    template: '<swb-mercht-tpl-role-resc-list :readOnly="readOnly" :roleId="roleId" ref="swb_mercht_tpl_role_resc_list"></swb-mercht-tpl-role-resc-list>',
                    data: {
                        roleId: srcTplId,
                        readOnly: true
                    },
                });
            },
            // pc操作权限：自建岗位
            showBusinessSetDlg: function (comId, roleId, name, srcTplId) {
                let self = this;
                openComRoleBusinessSetDlg(comId, roleId, name, srcTplId != -1, function () {
                    self.getComRoleList();
                });
            },
            // pc操作权限：职责权限
            showBusinessSetDlgForTpl: function (srcTplId) {
                let self = this;
                Vue.$showDialog({
                    title: '业务 - 设置',
                    width: 900,
                    height: 700,
                    showCloseBtn: false,
                    okVisible: false,
                    cancelText: '关闭',
                    template: '<swb-mercht-tpl-role-business-set :bizUnitLevel="bizUnitLevel" :readOnly="readOnly" :roleId="roleId" ref="swb_mercht_tpl_role_business_set"></swb-mercht-tpl-role-business-set>',
                    data: {
                        roleId: srcTplId,
                        bizUnitLevel: self.comInfo.bizUnitLevel,
                        readOnly: true,
                    }
                });
            },
            // 移动功能: 自建岗位
            appResc(row) {
                let self = this;
                let ctxVipLevel = this.userContext.scopeEntity.vipLevel;
                let vipLevel = getEnumMap('vipLevel', 'value2text');
                let vipLevelName = vipLevel[ctxVipLevel] || vipLevel[0];
                let bizUnitInfo = self.bizUnitInfo;
                openMobAppRoleRescDlg(row.id, vipLevelName, bizUnitInfo.bizUnitType, row.srcTplId != -1, function () {
                    self.getComRoleList();
                });
            },
            // 移动功能：职责权限
            appRescForTpl(srcTplId) {
                Vue.$showDialog({
                    title: '移动端资源',
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: '关闭',
                    template: '<swb-mercht-tpl-role-resc-for-mob-app :roleId="roleId" :readOnly="true" ref="swb_mob_app_role_resc"></swb-mercht-tpl-role-resc-for-mob-app>',
                    data: {
                        roleId: srcTplId,
                    }
                });
            },
            // 数据范围
            bizPermScopeBusinessSetDlg(srcTplId) {
                let self = this;
                this.getMerchtTplRoleById(srcTplId, function (merchtTplRoleInfo) {
                    if (Utils.isNoB(merchtTplRoleInfo.bizPermScopId) || merchtTplRoleInfo.bizPermScopId == -1) {
                        MsgBox.warning('当前岗位无业务范围，请在对应的职责权限关联');
                        return;
                    }
                    openBizPermScopeDlg(merchtTplRoleInfo.bizPermScopId, true, function () {
                        self.getComRoleList();
                    });
                });
            },
            // 关联 or 更换职责权限
            contactTpl(roleId, srcTplId) {
                let self = this;
                //
                let filter = {
                    bizUnitTypeX: self.bizUnitInfo.bizUnitType  // 机构的业务单元类型
                };
                let theDlg = Vue.$showDialog({
                    title: '职责权限选择',
                    width: 1200,
                    height: 700,
                    showCloseBtn: true,
                    template: '<swb-mercht-tpl-role-list-select :filter="filter" :radioFlag="true" ref="swb_tpl_com_role_list_select"></swb-mercht-tpl-role-list-select>',
                    data: {
                        filter: filter
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_tpl_com_role_list_select.getDlgResult() || {};
                        if (result.type == 'info') {
                            let tpl = result.data;
                            if (srcTplId == tpl.id) {
                                MsgBox.warning('更换的职责权限与原职责权限相同');
                                return false;
                            }
                            let postData = {};
                            postData.newTplRoleId = tpl.id;
                            postData.oldTplRoleId = srcTplId;
                            postData.comRoleIds = [roleId];
                            let theLoading = MsgBox.loading();
                            servicerAuthxApi.updateServicerComRoleContactTpl(postData, function (result) {
                                theLoading.close();
                                if (result.type == 'info') {
                                    theDlg.close();
                                    self.$message.success('操作成功!');
                                    self.getComRoleList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        } else {
                            Toast.show(result.message);
                        }
                        return false;
                    }
                });
            },
            // 启、禁用
            updateDisable: function (id, disabled) {
                let title = disabled ? '启用' : '禁用';
                let self = this;
                this.$confirm('确定' + title + '吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    postData.disabled = !disabled;
                    let theLoading = MsgBox.loading();
                    servicerAuthxApi.updateServicerComRoleForDisabled(postData, function (result) {
                        theLoading.close();
                        if (result.type == 'info') {
                            self.$message.success('操作成功!');
                            self.getComRoleList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            doDelete(id) {
                let self = this;
                this.$confirm('确定删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoading = MsgBox.loading();
                    servicerAuthxApi.deleteServicerComRole(postData, function (result) {
                        theLoading.close();
                        if (result.type == 'info') {
                            self.$message.success('操作成功!');
                            self.getComRoleList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            toQrCode(role) {
                let content = {
                    merchantId: role.merchantId,
                    merchantType: 4,    // 服务商
                    comId: role.comId,
                    comLevel: role.comLevel,
                    roleId: role.id
                };
                let postData = {
                    merchantId: role.merchantId,
                    merchantType: 4,
                    usage: 1,   // 入职
                    content: JSON.encode(content),
                    topTxt: '员工入职二维码',
                    btmTxt: role.name,
                };
                //
                let theLoading = MsgBox.loading();
                servicerAuthxApi.getServicerComRoleQrCodeUrl(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let qrCodeUrl = result.data;
                        showQrCodeImageDlg(qrCodeUrl, name, 300, 300, {
                            headText: '员工入职二维码',
                            footText: role.name,
                            headHeight: 30,
                            footHeight: 28
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 查询岗位人员
            showRefStaffList: function (roleId) {
                showComRoleStaffList(roleId);
            },
            // 获取职责权限
            getMerchtTplRoleById: function (tplRoleId, callbackFunc) {
                let postData = {
                    roleId: tplRoleId,
                };
                merchtAllApi.getMerchtTplRoleById(postData, function (retult) {
                    if (retult.type == 'info') {
                        callbackFunc(retult.data)
                    } else {
                        MsgBox.warning(retult.message);
                    }
                })
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/authx/ComRoleList.vue